export default "__VITE_ASSET__sVEJ3wVH__"